import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  nextAction,
} from '../../actions/navigation';
import Header from '../../components/Header';
import imgComplete from '../../assets/images/pending.svg';
import { parseUrlParams } from '../../utils/parseUrlParams';

const Declined = ({ checkinData, navigate, dispatch }) => {
  const match = useParams();

  const handleButtonClick = (e) => {
    const params = parseUrlParams(window.location.search);
    const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
    e.preventDefault();
    dispatch(nextAction({
      entityType: 'application',
      entityId: params.appid,
      workflowType,
    }));
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      <div className="content">
        <img src={imgComplete} alt="" />
        <h1>Agreement Signature Pending</h1>
        <p>{get(checkinData, 'state.data.message')}</p>
        {
          get(checkinData, 'state.data.showCallToActionButton') && (
            <div className="footer" style={{ marginTop: 50 }}>
              <div className="row">
                <div className="col">
                  <button type="button" onClick={handleButtonClick} className="btn arrow">Continue Signing Loan Document</button>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

Declined.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Declined);
